import { render, staticRenderFns } from "./Patient.vue?vue&type=template&id=194504e6&scoped=true&"
import script from "./Patient.vue?vue&type=script&lang=js&"
export * from "./Patient.vue?vue&type=script&lang=js&"
import style0 from "./Patient.vue?vue&type=style&index=0&id=194504e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194504e6",
  null
  
)

export default component.exports